import type { QuizDefinition, UiCopy } from "@quiz/quiz-core";

const en: Required<UiCopy> = {
  back: "Back",
  progressLabel: "Progress",
  resultEyebrow: "Your results are ready",
  resultCta: "Open full recommendation",
  resultBreakdownTitle: "Score breakdown",
  lockedTitle: "Full plan is locked",
  lockedText: "Submit the form to reveal the complete recommendation.",
  fullResultTitle: "Full recommendation",
  phoneSearch: "Search country",
  phoneAria: "Phone number",
  invalidPhone: "Enter a valid international phone number.",
  nameRequired: "Name is required.",
  emailRequired: "Email is required.",
  privacyRequired: "Privacy consent is required.",
  privacyConsent: "I agree to the privacy policy",
  marketingConsent: "I agree to receive helpful learning tips",
  sending: "Sending...",
  submitError: "Lead submit failed",
  leadSaved: "Lead saved",
  leadSavedLocal: "Saved locally",
  fullResultReady: "Full result is ready",
  restart: "Restart quiz"
};

const uk: Required<UiCopy> = {
  back: "Назад",
  progressLabel: "Прогрес",
  resultEyebrow: "Твої результати готові",
  resultCta: "Показати повну рекомендацію",
  resultBreakdownTitle: "Як розподілились напрямки",
  lockedTitle: "Повний план відкриється після заявки",
  lockedText: "Залиш контакти, і ми покажемо повну рекомендацію без технічних деталей.",
  fullResultTitle: "Повна рекомендація",
  phoneSearch: "Пошук країни",
  phoneAria: "Номер телефону",
  invalidPhone: "Введи коректний міжнародний номер телефону.",
  nameRequired: "Вкажи ім'я.",
  emailRequired: "Вкажи email.",
  privacyRequired: "Потрібна згода з політикою конфіденційності.",
  privacyConsent: "Погоджуюся з політикою конфіденційності",
  marketingConsent: "Хочу отримувати корисні поради про навчання",
  sending: "Надсилаємо...",
  submitError: "Не вдалося надіслати заявку",
  leadSaved: "Заявку збережено",
  leadSavedLocal: "Збережено локально",
  fullResultReady: "Повний результат готовий",
  restart: "Пройти ще раз"
};

export type ResolvedUiCopy = Required<UiCopy>;

export function getUiCopy(quiz: QuizDefinition): ResolvedUiCopy {
  const language = quiz.metadata.language.toLowerCase();
  const defaults = language.startsWith("uk") ? uk : en;
  return { ...defaults, ...quiz.uiCopy };
}
